// import React, { useState } from 'react';

import Header from './pages/header';
import Footer from './pages/footer';

import './App.css';
import Home from './pages/home';
import AppointmentPage from './pages/AppointmentPage';
import { Route, Routes } from 'react-router-dom';
import About from './pages/about';
import Services from './pages/services';
import ServicesDetails from './pages/servicesdetails';
import Contact from './pages/contact';
import Therapists from './pages/therapists';
import Gallery from './pages/gallery';
import PrivacyPolicy from './pages/privacypolicy';
import TermsConditions from './pages/termsConditions';
import Disclaimer from './pages/disclaimer';
import PageLoader from './pages/pageloader';
import { useEffect, useState } from 'react';
import BookingPage from './pages/BookingPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

export default function App() {
const [loading, setLoading] = useState(true);
useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000); // fast & smooth
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <PageLoader />;
  return (
    <div className="app-root">

      <Header/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServicesDetails />} />
        <Route path="/therapists" element={<Therapists />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/appointment" element={<AppointmentPage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path= "/appointment-booking" element={<BookingPage />} />
        <Route path="/brightlife-admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Footer />

       
    </div>
  );
}
